import request from '../utils/request';

/**
 * 获取用户设备历史分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export const getUserDeviceHistoryList = (params) => {
  return request({
    url: '/user-device-history/list',
    method: 'get',
    params
  });
};

/**
 * 获取用户常用设备列表
 * @param {number} userId 用户ID
 * @param {number} limit 限制数量
 * @returns {Promise} 请求结果
 */
export const getMostFrequentDevices = (userId, limit = 5) => {
  return request({
    url: `/user-device-history/frequent/${userId}`,
    method: 'get',
    params: { limit }
  });
};

/**
 * 检查设备是否为用户的常用设备
 * @param {number} userId 用户ID
 * @param {string} deviceId 设备ID
 * @returns {Promise} 请求结果
 */
export const isFrequentDevice = (userId, deviceId) => {
  return request({
    url: '/user-device-history/check-frequent',
    method: 'get',
    params: { userId, deviceId }
  });
}; 